import React from 'react';
import {SketchPicker} from "react-color";
import {Popover} from 'antd';
import styles from './ColorPicker.module.css';

export default class ColorPicker extends React.PureComponent {

    render() {
        const {placement, handleChange, color} = this.props;
        return (
            <div className={styles.container}>
                <h6>Network color</h6>
                <Popover placement={placement}
                         content={<SketchPicker color={color} onChange={handleChange}/>}
                         trigger="click">
                    <div className={styles.containerWrapperBtn}>
                        <div className={styles.container_pickerBtn}>
                            <div style={{backgroundColor: color}} className={styles.pickerBtn}/>
                        </div>
                    </div>
                </Popover>
            </div>
        )
    }
}